<template>
  <vue-ueditor-wrap v-model="ueContent" :config="editorConfig" :editor-dependencies="editorDependencies"></vue-ueditor-wrap>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap';
import {getToken} from '@/utils/auth'

export default {
  name: 'UEditor',
  props: {
    value: {}
  },
  components: {
    VueUeditorWrap
  },
  watch: {
    value: {
      handler(newValue) {
        this.ueContent = newValue
      },
      immediate: true
    },
    ueContent(newValue) {
      this.$emit('input', newValue)
    }
  },
  data() {
    return {
      ueContent: null,
      editorConfig: {
        serverUrl: process.env.VUE_APP_BASE_API + "/ueditor/upload",
        UEDITOR_HOME_URL: '/UEditor/',
        maximumWords: 20000,
        catchRemoteImageEnable: false, // 不抓取远程图片，保存的时候由后端处理
        headers: {'Authorization': getToken(), 'Terminal-Type': 'PC', platform: 'pc'},
        initialFrameHeight: 400,
      },
      editorDependencies: [
        'ueditor.config.js',
        'ueditor.all.min.js',
        // 添加秀米相关的资源
        'xiumi/xiumi-ue-dialog-v5.js',
        'xiumi/xiumi-ue-v5.css',
      ]
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
